import * as React from 'react';
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import {Dispatch, useState} from "react";

const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

type requestFormProps = {
    bagsDetected: boolean,
    setBagsDetected: React.Dispatch<React.SetStateAction<boolean>>,
    setExtraInformationAboutTrashes: React.Dispatch<React.SetStateAction<boolean>>,
    calculatedPrice: any,
    setManualTrashPrice: Dispatch<any>,
    apiUrl: string,
    city: string,
    selectedSize: string,
    setTooHeavy: Dispatch<any>,
    setBagsCount: Dispatch<any>
};

export const BagsDetected = ({
                                 bagsDetected,
                                 setBagsDetected,
                                 setExtraInformationAboutTrashes,
                                 calculatedPrice,
                                 setManualTrashPrice,
                                 apiUrl,
                                 city,
                                 selectedSize,
                                 setTooHeavy,
                                 setBagsCount
                             }: requestFormProps) => {
    const [open, setOpen] = React.useState(false);
    const [openAfter, setAfterOpen] = React.useState(false);
    const [enteredBagsCount, setEnteredBagsCount] = useState(0);

    const handleClose = async (event?, reason?) => {
        if (reason === 'backdropClick') {
            return;
        }

        setBagsCount(enteredBagsCount);

        try {
            const response = await fetch(apiUrl + "price-bags/" + encodeURIComponent(city) + "/" + encodeURIComponent(selectedSize) + "/" + enteredBagsCount, {
                method: "GET"
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (data.totalPrice) {
                if (data.tooHeavy === false) {
                    setManualTrashPrice(data.totalPrice);
                    setTimeout(() => {
                        calculatedPrice.current?.scrollIntoView({behavior: "smooth"});
                    }, 100);
                } else {
                    setTooHeavy(true);
                    setManualTrashPrice('');
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            setOpen(false);
            setAfterOpen(false);
            setBagsDetected(false);
        }
    };

    React.useEffect(() => {
        if (bagsDetected) {
            setOpen(true);
        }
    }, [bagsDetected]);


    const handleSelection = (event) => {
        const count = parseInt(event.target.value, 10) || 0;
        setEnteredBagsCount(count);
        setExtraInformationAboutTrashes(event.target.value);
    };


    return (
        <>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                maxWidth={'md'}
                disableEscapeKeyDown
            >
                <DialogTitle sx={{m: 0, p: 2, mr: 5}} id="customized-dialog-title"></DialogTitle>
                <DialogContent dividers>
                    <h2>Aptikome maišus</h2>
                    <p>Jei juose yra <b>sunkios atliekos</b>, kaip betonas, plytos, tinkas ar panašios statybinės
                        atliekos, nurodykite maišų kiekį.</p>
                    <p><b><small>Įrašykite maišų skaičių</small></b></p>
                    <p><input type={"number"} className={"modal-number-input"} onChange={handleSelection}/></p>

                    <button className="btn primary-btn" onClick={handleClose} disabled={openAfter}>Pateikti</button>
                    <p><small>Šis kiekis padeda tiksliau įvertinti svorį ir galutinę išvežimo kainą.</small></p>
                </DialogContent>
            </BootstrapDialog>
        </>
    );
}
